import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "../api";

export default function CompanyCommsOverview() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");
  const [onlyMissing, setOnlyMissing] = useState(true);

  const load = useCallback(() => {
    api.get("/companies/comms/overview").then((r) => setRows(r.data || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const sendOne = async (cid, name, missing) => {
    if (!window.confirm(`Inviare la richiesta di consenso ai ${missing} destinatari mancanti di ${name}?`)) return;
    setBusy(cid); setMsg("");
    try {
      const r = await api.post(`/companies/${cid}/send-consent`);
      setMsg(`${name}: inviate ${r.data.sent}, saltate ${r.data.skipped}.`);
      load();
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(""); }
  };

  const shown = onlyMissing ? rows.filter((r) => r.missing_count > 0) : rows;
  const totMissing = rows.reduce((a, r) => a + r.missing_count, 0);

  return (
    <div className="panel" style={{ marginTop: 16 }} data-testid="comms-overview-panel">
      <div className="toolbar">
        <h3 style={{ margin: 0 }}>Consensi per azienda</h3>
        <div className="spacer" />
        <label className="muted" style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
          <input type="checkbox" checked={onlyMissing} onChange={(e) => setOnlyMissing(e.target.checked)} style={{ width: "auto" }} data-testid="overview-only-missing" />
          Solo con destinatari mancanti
        </label>
      </div>
      <p className="muted" style={{ fontSize: 13 }}>
        Per ogni azienda: email idonee (azienda + soci, esclusi consulenti del lavoro). <strong>{totMissing}</strong> destinatari non ancora contattati in totale.
      </p>
      <table style={{ marginTop: 10 }}>
        <thead><tr><th>Azienda</th><th>Idonei</th><th>Confermati</th><th>Mancanti</th><th></th></tr></thead>
        <tbody>
          {shown.map((r) => (
            <tr key={r.company_id} data-testid={`overview-row-${r.company_id}`}>
              <td><Link to={`/aziende/${r.company_id}`}>{r.name}</Link></td>
              <td>{r.eligible_count}</td>
              <td>{r.confirmed_count}</td>
              <td>{r.missing_count > 0 ? <strong style={{ color: "#d97706" }}>{r.missing_count}</strong> : "—"}</td>
              <td>
                {r.missing_count > 0 && (
                  <button className="btn sm primary" disabled={busy === r.company_id} onClick={() => sendOne(r.company_id, r.name, r.missing_count)} data-testid={`overview-send-${r.company_id}`}>
                    {busy === r.company_id ? "Invio…" : "Invia consenso"}
                  </button>
                )}
              </td>
            </tr>
          ))}
          {shown.length === 0 && <tr><td colSpan={5}><div className="empty">Nessuna azienda con destinatari mancanti. ✅</div></td></tr>}
        </tbody>
      </table>
      {msg && <p className="muted" data-testid="overview-msg" style={{ marginTop: 8 }}>{msg}</p>}
    </div>
  );
}
